/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import React from 'react';
import PropTypes from 'prop-types';
import styles from './snapshotsModal.scss';

class SnapshotListItem extends React.PureComponent {
    static propTypes = {
        name: PropTypes.string.isRequired,
        snapshot: PropTypes.object.isRequired,
        selectSnapshot: PropTypes.func.isRequired,
    };

    onClick = (e) => {
        e.stopPropagation();
        this.props.selectSnapshot(this.props.snapshot);
    };

    render() {
        return (
            <li
                key={this.props.snapshot.time}
                onClick={this.onClick}
            >
                <button className={styles.snapshotsItemButton} onClick={this.onClick}>
                    {this.props.name}
                </button>
            </li>
        );
    }
}

export default SnapshotListItem;
